/**
 * @generated SignedSource<<74f14a40150654362f864546d846418b>>
 * @relayHash 42ad701310ee22edb8e0a5673f8e62ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09928728bfef8ab399de527ab616a64ed0f1aa9ac49017e75285fe884a371e0c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterPageDeleteInput = {
  helpCenterPageAri: string;
};
export type mainDeletePageMutation$variables = {
  cloudId: string;
  input: HelpCenterPageDeleteInput;
};
export type mainDeletePageMutation$data = {
  readonly helpCenter: {
    readonly deleteHelpCenterPage: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type mainDeletePageMutation = {
  response: mainDeletePageMutation$data;
  variables: mainDeletePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterPageDeletePayload",
        "kind": "LinkedField",
        "name": "deleteHelpCenterPage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainDeletePageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainDeletePageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "09928728bfef8ab399de527ab616a64ed0f1aa9ac49017e75285fe884a371e0c",
    "metadata": {},
    "name": "mainDeletePageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4ad74586b75c73237b36cc828a14f7e7";

export default node;
